interface Alert {
  id?: string;
  showIcon?: boolean;
  icon: AlertIcon;
  html?: string;
  text?: string;
  title?: string;
  showCancel?:boolean;
  textCancel?:string;
  showAccept?:boolean;
  textAccept?:string;
  acceptButton?: CustomButtonAlert;
  cancelButton?: CustomButtonAlert;
  positionBtn?: "center" | "left" | "right";
}

enum AlertIcon {
  INFO = 'info-circle',
  WARN = 'exclamation-triangle',
  SUCCESS = 'check-circle',
  ERROR = 'times-circle',
  QUESTION = 'question-circle'
}

interface ResponseAlert {
  accept?: boolean;
  cancel?: boolean;
}


interface CustomAlert {
  breakpoints?: any;
  styleClass?: string;
  modal?: boolean;
  closable?: boolean;
  data?: Alert;
  timer?: number;
  autoClose?:boolean;
  position?: positionType;

}

interface CustomButtonAlert {
    label: string;
    icon?: string;
    class?: string | string[] | Set<string> | {[p: string]: any} | null | undefined;
    show?: boolean;
    disabled?: boolean;
    style?: {[p: string]: any} | null | undefined  ;
    action?: () => void;
}

type positionType = "center" | "top" |  "bottom" | "left" | "right" | "top-left" | "top-right" | "bottom-left" | "bottom-right";

export {
  CustomAlert, Alert, AlertIcon, CustomButtonAlert, ResponseAlert
}
